export const FALLBACK_MESSAGE = {
    notCommunicated: 'N/C',
    notAvailable: 'N/A',
    noData: 'No data',
    noResults: 'No results',
    error: 'An error occured. Try again later',
    unknown: 'Unknown',
    dash: '-',
};
